import axios from 'axios'
export default {
  name: 'proveedor',
  components: { },
  data () {
    return {  
    }
  },
  props:['name'],
  mounted() {
  },
  methods: {
  },
  computed: {
    nombre: {
    get() {
      return this.name
    },
    set (value) {
      this.$emit('proveedor:change', this.nombre)
    }
   }
  },
  watch: {
  }
}


// WEBPACK FOOTER //
// ./src/components/js/registroproveedores.js